import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import SingleState from '../states/single.state';

interface ErrorData {
    [key: string]: any;
}

const initialState: SingleState = {
    data: {},
    loading: false,
    error: null,
};

const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        setErrorData: (state, action: PayloadAction<ErrorData>) => {
            return {
                ...state,
                data: action.payload
            };
        },
        resetErrorData: (state) => {
            return {
                ...state,
                data: {}
            };
        },
    },
});

export const { setErrorData,resetErrorData } = errorSlice.actions;
export default errorSlice.reducer;
